"use strict";
// packages/contracts/src/painel-home.ts — Fase 17.8, Plano 01 (D-06, D-07, D-08, D-24, D-28).
// Contrato das homes por perfil do painel: um endpoint por perfil (GET /api/v1/painel/home/:perfil).
// Regras transversais:
//  - campo ausente na resposta significa "sem permissão para ver"; nunca é zero;
//  - dinheiro é string decimal arredondada no PostgreSQL (ROUND(...,2)::text), nunca number calculado no Node;
//  - nenhum campo carrega cor ou hex: a apresentação (matiz, tom) é decidida só no web;
//  - `INDISPONIVEL` significa que a consulta daquela região falhou (o resto da resposta continua válido);
//  - `SEM_MEDICAO` significa que não há base para medir (zero medido é `MEDIDO` com valor 0);
//  - série: `null` é dia sem medição (a linha do gráfico é interrompida) e nunca vira 0.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ID_PERFIS_HOME = void 0;
/** Ordem fixa dos perfis (D-02 da 17.8: primeiro acesso segue PCP, Qualidade, Almoxarifado, Compras, Faturamento, Diretoria). */
exports.ID_PERFIS_HOME = ['pcp', 'qualidade', 'almoxarifado', 'compras', 'faturamento', 'diretoria'];
//# sourceMappingURL=painel-home.js.map